import * as React from "react";

import { FileTypeFilter } from "../../models/ClientConfiguration/FileTypeFilter";
import FileExtensionsInput from "../common/FileExtensionsInput";
import OutlinedDiv from "../common/OutlinedDiv";

interface FileExtensionFilterInputProps {
  filters: FileTypeFilter[];
  onChange: (value: FileTypeFilter[]) => void;
  disabled?: boolean;
}
const FileExtensionsFilterInput: React.FC<FileExtensionFilterInputProps> = ({
  filters,
  onChange,
  disabled = false,
}) => {
  return (
    <OutlinedDiv label="File Extension Filters" disabled={disabled}>
      <FileExtensionsInput
        placeholder="Add extension"
        extensions={filters.map((f) => f.fileExtension ?? "")}
        onExtensionsChange={(newExtensions) => {
          onChange(newExtensions.map((e) => ({ fileExtension: e })));
        }}
        disabled={disabled}
      />
    </OutlinedDiv>
  );
};

export default FileExtensionsFilterInput;
